import { ClipboardDocumentCheckIcon, Square3Stack3DIcon } from "@heroicons/react/24/outline";
import React from "react";
import Transactions from "src/components/Clients/List/BodyContent/ClientTransactions/Transactions";
import Tabs from "src/components/Shared/Tabs/Tabs";
import { H1 } from "src/components/Shared/Text/Headers";
import PlanList from "src/components/Site/Plans/List/PlanList";

const Billing = () => {
  const tabs = [
    { name: "Billing Plans", icon: Square3Stack3DIcon, component: <PlanList /> },
    { name: "Transactions", icon: ClipboardDocumentCheckIcon, component: <Transactions /> },
  ];

  return (
    <>
      <H1>Billing & Payments</H1>
      <Tabs tabs={tabs} />
    </>
  );
};
export default Billing;
